import React from 'react';
import './priceHeader.css';
import { useDispatch } from "react-redux";
import { priceFormAction } from "../../../redux/rootReducer";
import { PRICE_FORM_INITIAL } from "../../../redux/initialStateConstant";

const PriceHeader = ({ currentType, setCurrentType, types, tabs, setTabs }) => {
    const dispatch = useDispatch();

    return (
        <>
            <div className="tabs">
                {
                    Object.keys(types).map(elem => {
                        return (
                            <div
                                className={ `tab ${ currentType === elem ? 'tab--active' : '' }` }
                                key={ elem }
                                onClick={ () => setCurrentType(elem) }
                            >{ types[elem].name }</div>
                        );
                    })
                }
            </div>
            <div className={ `button price__hide ${ tabs && 'price__hide--tabs' }` }
                 style={{ position: 'absolute', right: '148px' }}
                 onClick={ () => setTabs(!tabs) }
            >{ tabs ? 'Скрыть вкладки' : 'Показать вкладки' }</div>
            <div className="button button--add"
                onClick={ () => {
                    dispatch(priceFormAction({
                        ...PRICE_FORM_INITIAL,
                        open: true
                    }));
                } }
            >
                Добавить
            </div>
        </>
    );
};

export default PriceHeader;